<div class="footer-container">
  <footer class="footer-content">
    <div class="footer-row">
      <div class="footer-col footer-left">
        © 2026 Copyright:
        <a
          class="footer-link"
          href="https://accoladeelectronics.com/"
          target="_blank"
        >
          <b>Accolade Electronics Pvt. Ltd.</b>
        </a>
      </div>
      <div class="footer-col footer-right">
        <span><b>Version:</b> {{ version }}</span>
      </div>
    </div>
  </footer>
</div>
